import React from 'react'
import { Setters } from 'src/features/atoms/glove/japan/Components'
import { OrderPageTemplate } from 'src/Components/Domain/OrderPageTemplate'
import { infieldReducer } from 'src/features/atoms/glove/japan/slice/infielder'
import { State, PartialAction } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { BaseModelSelector } from 'src/Components/Domain/BaseModelSelector'
import { useRouter } from 'next/router'
import { atomsBaseModel } from 'src/features/atoms/glove/japan/constants/baseModel'
import { SET_FIGURE_PANEL_NUMBER } from 'src/features/atoms/glove/japan/constants/actionType'

const AtomsInfielder: React.FC = () => {
  const { t } = useLocale()
  const router = useRouter()
  const models = atomsBaseModel(t, router)
  const [state, dispatch] = React.useReducer(infieldReducer, t.INITIAL_STATE_INFIELDER) as [State, React.Dispatch<PartialAction>]
  const { figurePanelNum } = state
  const handleFigurePanelNum = (_, newValue: 0 | 1) => dispatch({ ...state, type: SET_FIGURE_PANEL_NUMBER, figurePanelNum: newValue })
  return (
    <OrderPageTemplate
      breadcrumbTrail={`${t.HARD} / ATOMS / ${t.INFIELDER}`}
      brand={'atoms'}
      {...{ figurePanelNum, state, dispatch, handleFigurePanelNum }}
    >
      <BaseModelSelector {...{ state, models, dispatch }} />
      <Setters {...{ state, figurePanelNum, dispatch }} />
    </OrderPageTemplate>
  )
}

export default AtomsInfielder
